import WhmcsApi from "../../WhmcsApi";

let signal = null;

export const setSignalDataOxxo = (signal) => {
  signal = signal;
};

export const addOrderOxxo = async (products, token, invoiceId = null, facturacionAutomatica = false, nbps = false, promocode = "") => {

  signal = signal;

  try {
    const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi

    if (signal) {
      whmcsApi.setSignal(signal); // Set signal in the WhmcsApi instance
    }
    const payload = {products: JSON.stringify(products), facturacionAutomatica, nbps, promocode}
    if (invoiceId != null) {
      payload.invoiceid = invoiceId
    }
    
    const response = await whmcsApi.request(
      "addOrderOxxo",
      payload,
      "POST",
      token
    );
    return response;
  } catch (error) {
    console.error("Failed to fetch Add Order:", error);
    return false;
  }
};
